// extracted by mini-css-extract-plugin
module.exports = {"typingIdle":"TypingLabel_typingIdle__cauNK","typingActive":"TypingLabel_typingActive__1whlR","typingText":"TypingLabel_typingText__2fXT2","name":"TypingLabel_name__OuVRG"};